import { useState } from "react";
import { BillingToggle } from "./pricing/BillingToggle";
import { PricingCard } from "./pricing/PricingCard";
import { plans } from "./pricing/pricingData";

interface PricingSectionProps {
  standalone?: boolean;
}

export const PricingSection = ({ standalone }: PricingSectionProps) => {
  const [isAnnual, setIsAnnual] = useState(false);

  return (
    <section className="py-16 md:py-24 bg-background">
      <div className="container mx-auto px-4 space-y-12">
        <BillingToggle isAnnual={isAnnual} setIsAnnual={setIsAnnual} />
        
        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {plans.map((plan) => (
            <PricingCard
              key={plan.name}
              {...plan}
              isAnnual={isAnnual}
            />
          ))}
        </div>
      </div>
    </section>
  );
};